import { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './Contact.scss';

export default function Contact() {
	const captcha = useRef(null);
	const [reCaptcha, setReCaptcha] = useState(null);

	const onChange = () => {
		if (captcha.current.getValue()) {
			setReCaptcha(true);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const form = document.getElementById('formContact');
		const alert = document.getElementById('alert-response');
		const data = new FormData(form);

		form.classList.add('was-validated');

		if (captcha.current.getValue()) {
			setReCaptcha(true);
		} else {
			setReCaptcha(false);
		}

		if (
			data.get('validationName') &&
			data.get('validationEmail') &&
			data.get('validationPhone') &&
			data.get('validationSubjet') &&
			data.get('validationMessage') &&
			captcha.current.getValue()
		) {
			fetch('email.php', {
				method: 'POST',
				body: data,
			});

			alert.classList.remove('show-alert');
			document.getElementById('formContact').reset();
			captcha.current.reset();
			form.classList.remove('was-validated');
		}
	};

	return (
		<section className='contact py-5' id='contact'>
			<div className='container'>
				<div className='show-alert' id='alert-response'>
					<div
						className='alert alert-success alert-dismissible fade show fs-5 text-center'
						role='alert'
					>
						Mensaje Enviado!
						<button
							type='button'
							className='btn-close'
							data-bs-dismiss='alert'
							aria-label='Close'
						></button>
					</div>
				</div>
				<div className='row'>
					<div className='col-12 col-md-5 col-lg-4 px-0'>
						<div className='contact-img fondoCoverContact vh-100 d-flex align-items-center'>
							<div className='text-white'>
								<h4 className='display-4 fw-bold text-center pb-4'>Contáctanos</h4>
								<div className='d-flex px-3'>
									<i className='bi bi-telephone'></i>
									<p className='ps-1'>+52 7704 1104</p>
								</div>
								<div className='d-flex px-3'>
									<i className='bi bi-envelope-open'></i>
									<p className='ps-1'>contacto@ekklogistics.com</p>
								</div>
								<div className='d-flex px-3'>
									<i className='bi bi-geo-alt'></i>
									<p className='ps-1'>
										Calz Legaria 549, 10 de Abril, Miguel Hidalgo, 11250 Ciudad de México,
										CDMX
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className='col-12 col-md-7 col-lg-8 d-flex align-items-center border-color-primary'>
						<form
							className='row g-3 p-5 needs-validation'
							onSubmit={handleSubmit}
							id='formContact'
							noValidate
						>
							<div className='col-md-6'>
								<label htmlFor='validationName' className='form-label fs-dark fs-5'>
									Nombre
								</label>
								<input
									type='text'
									className='form-control'
									id='validationName'
									name='validationName'
									required
								/>
								<div className='valid-feedback'>Se ve bien!!</div>
							</div>
							<div className='col-md-6'>
								<label htmlFor='validationEmail' className='form-label fs-dark fs-5'>
									Correo
								</label>
								<input
									type='email'
									className='form-control'
									id='validationEmail'
									name='validationEmail'
									required
								/>
								<div className='valid-feedback'>Se ve bien!!</div>
							</div>
							<div className='col-md-6'>
								<label htmlFor='validationPhone' className='form-label fs-dark fs-5'>
									Teléfono
								</label>
								<input
									type='text'
									className='form-control'
									id='validationPhone'
									name='validationPhone'
									required
								/>
								<div className='valid-feedback'>Se ve bien!!</div>
							</div>
							<div className='col-md-6'>
								<label htmlFor='validationSubjet' className='form-label fs-dark fs-5'>
									Asunto
								</label>
								<input
									type='text'
									className='form-control'
									id='validationSubjet'
									name='validationSubjet'
									required
								/>
								<div className='valid-feedback'>Se ve bien!!</div>
							</div>
							<div className='col-md-12'>
								<label htmlFor='validationMessage' className='form-label fs-dark fs-5'>
									Mensaje...
								</label>
								<textarea
									className='form-control'
									id='validationMessage'
									name='validationMessage'
									rows='3'
									required
								></textarea>
							</div>
							<div className='col-md-12 d-flex align-items-center'>
								<ReCAPTCHA
									ref={captcha}
									sitekey='6LfMuTgcAAAAAPdXT-cFCeby2oFeeJxakbjAPQ_3'
									onChange={onChange}
								/>
								{reCaptcha === false && (
									<p className='fs-5 m-0 ps-2 text-danger'>Por favor acepte el Captcha</p>
								)}
							</div>
							<div className='col-12 d-flex justify-content-end'>
								<button type='submit' className='btn  btn-lg bg-ligt-color'>
									Enviar
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
	);
}
